import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class WebUserService {

  constructor(
    private http: HttpService,
  ) { }
  
  getList(data?: any) {
    return this.http.post(Path.WEB_USER.GET_LIST, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.WEB_USER.GET_DETAIL, params);
  }   

  getCompanyList(data?: any) {
    return this.http.post(Path.COMPANY.GET_LIST, data);
  }

  insert(data?: any) {
    return this.http.post(Path.WEB_USER.INSERT, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_WEB_USER_MAINTENACE, data);
  }
}
